import { Component, OnInit } from '@angular/core';
import { Empty_Ticket_Interface, Ticket_Interface } from 'src/app/Interface/Ticket_Interface';
import { Ticket_Ref_Interface } from 'src/app/Interface/Ticket_Ref_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketService } from 'src/app/Service/Ticket/Ticket.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-TicketList',
  templateUrl: './TicketList.component.html',
  styleUrls: ['./TicketList.component.scss']
})
export class TicketListComponent implements OnInit {

  Token:String=""
  typeUser:any
  Switcher_view:number=-1
  Show_Draft_Ticket:number=1
  page=0

  constructor(
    private Alertify_Service:AlertifyService,
    private Ticket_Service:TicketService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.typeUser=localStorage.getItem('Daro_User_Type');
    var MenuId=1102
    if(this.typeUser=='1' || this.typeUser=='2')
     MenuId=1104

    this.Nav_Service.CheckValidPage(this.Token,MenuId).subscribe(
      data=>{
        this.ReadData_Ticket()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  Proccessing:boolean=false
  Ticket_Datalist:Array<Ticket_Interface>=[]
  ReadData_Ticket(){
    this.Seleted_Ticket_Item=Empty_Ticket_Interface()
    this.Proccessing=true
    this.Ticket_Datalist=[]
    this.Ticket_Service.GetRecord(this.Token,this.Show_Draft_Ticket).subscribe(
      data=>{
        this.Proccessing=false
        this.Ticket_Datalist=data
      }
    )
  }

  BaseUrl=environment.BaseUrl
  Proccessing_Ref:boolean=false
  canReply:boolean=false
  Ticket_Datalist_Ref:Array<Ticket_Ref_Interface>=[]

  Seleted_Ticket_Item:Ticket_Interface=Empty_Ticket_Interface()

  ReadData_Ref_Ticket(item:Ticket_Interface){
    this.canReply=false
    this.Rest_List_Selection()
    item.selected=true
    this.Seleted_Ticket_Item=item
    this.Proccessing_Ref=true
    this.Ticket_Datalist_Ref=[]
    this.Ticket_Service.GetDetail(this.Token,item.id).subscribe(
      data=>{
        this.Proccessing_Ref=false
        this.Ticket_Datalist_Ref=data['result']
        this.canReply=data['canReply']
      }
    )
  }


  Rest_List_Selection(){
    for (let item of this.Ticket_Datalist)
    {
      item.selected=false
    }
  }

  Show_View_ReplyForm(){
    this.Switcher_view=0
  }

  OnGet_Back_Ticket(id:number){

    this.Switcher_view=id
    this.ReadData_Ref_Ticket(this.Seleted_Ticket_Item)

  }

}
